"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var react_player_1 = __importDefault(require("react-player"));
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var styled_1 = require("./styled");
var Buttons_1 = require("../Buttons");
var Typo_1 = require("../Typo");
var EmbedLinkModal_1 = require("./comps/EmbedLinkModal");
var themes_1 = require("../../themes");
var useFakeUploadImpression_1 = require("../../utilsOolib/useFakeUploadImpression");
var bannerContext_1 = require("../Banners/bannerContext");
var VideoActionMenu_1 = require("./comps/VideoActionMenu");
var FileUploadWrapper_1 = require("../FileUploadWrapper");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var utils_1 = require("./utils");
function VideoInput(_a) {
    var id = _a.id, label = _a.label, sublabel = _a.sublabel, isRequired = _a.isRequired, _value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly, lightPlayer = _a.light, _b = _a.enableVideoUpload, enableVideoUpload = _b === void 0 ? false : _b, isInRTE = _a.isInRTE, invert = _a.invert, files = _a.files, // //used by RTEVideoInput
    width = _a.width, height = _a.height;
    var props = arguments[0];
    //backwards compatibility
    var value = typeof _value === 'string'
        ? [{ publicUrl: _value }]
        : _value;
    var _c = (0, react_1.useState)(false), showEmbedLinkModal = _c[0], setShowEmbedLinkModal = _c[1];
    var theme = (0, styled_components_1.useTheme)();
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var _d = (0, react_1.useState)(undefined), uploadProgress = _d[0], setUploadProgress = _d[1];
    var inputRef = (0, react_1.useRef)();
    var handleUploadProgess = function (progress) { return setUploadProgress(progress); };
    var isUploadedVideo = function (value) { return value && Object.keys(value === null || value === void 0 ? void 0 : value[0]).length > 1; };
    var _e = (theme === null || theme === void 0 ? void 0 : theme.useUploadMedia({
        mediaConfigs: {
            type: "files",
            folderName: "videos",
            mediaType: "video",
        },
        handleUploadProgess: handleUploadProgess,
    })) ||
        (0, useFakeUploadImpression_1.useFakeUploadImpression)({ handleUploadProgess: handleUploadProgess, fileType: "video" }), upload = _e.mutate, isLoading = _e.isLoading;
    var handleUpload = function (_a) {
        // onChange(id, undefined) //so that the prev video is cleared and loader shows up
        var files = _a.files;
        if (!files)
            return;
        if (!upload)
            return;
        upload(files, {
            onSuccess: function (data) {
                onChange(id, [data[0].fileData]);
            },
            onError: function (err) {
                var _a;
                SET_ALERT_BANNER(((_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors[0].msg) || err.message, "red", 3500);
                onChange(undefined);
            },
        });
    };
    (0, react_1.useEffect)(function () {
        if (files) {
            handleUpload({ files: files });
        }
    }, []);
    var createVideoPreview = function (_a) {
        var _b;
        var value = _a.value, _c = _a.actionMenuButton, actionMenuButton = _c === void 0 ? false : _c;
        var url = value && ((_b = value[0]) === null || _b === void 0 ? void 0 : _b.publicUrl);
        var _d = (0, utils_1.verifyAndGetGoogleDrivePreviewableUrl)(url), isPreviewableGoogleDriveUrl = _d.isPreviewableGoogleDriveUrl, googleDrivePreviewableUrl = _d.googleDrivePreviewableUrl;
        switch (true) {
            case !url:
                return null;
            case isPreviewableGoogleDriveUrl:
                return (react_1.default.createElement("div", { style: { position: 'relative', paddingBottom: '56%' } },
                    react_1.default.createElement("iframe", { src: googleDrivePreviewableUrl, width: "100%", height: "100%", style: { position: 'absolute', top: 0, left: 0 }, allow: "autoplay", allowFullScreen: true })));
            case !(0, utils_1.canPlay)(url):
                return (react_1.default.createElement(Typo_1.SANS_3_4, { color: themes_1.colors.red }, "Error displaying video. Make sure you've added the right link or you have permission to share publicly."));
            default:
                if (url.indexOf("&list=") !== -1) {
                    var regex = /(?:\?|)v=([a-zA-Z0-9_-]{11})/; //Regular expression to match the video ID in a YouTube link
                    // 1- Extract the video URL from the playlist link - value.split('&list=')[0]
                    // 2- Use the regular expression to extract the video ID from the video URL - match(regex)[1]
                    // 3- Construct the final video URL using the extracted video ID  - value = 'https://www.youtube.com/watch?v=' + value.split('&list=')[0].match(regex)[1];
                    url =
                        "https://www.youtube.com/watch?v=" +
                            url.split("&list=")[0].match(regex)[1];
                }
                return (react_1.default.createElement(styled_1.StyledVideoEmbedPreviewSection, { style: { height: height } },
                    actionMenuButton && react_1.default.createElement(VideoActionMenu_1.VideoActionMenu, { isInRTE: isInRTE, value: value, inputRef: inputRef, setShowEmbedLinkModal: setShowEmbedLinkModal, onChange: onChange, isUploadedVideo: isUploadedVideo, invert: invert, id: id }),
                    react_1.default.createElement(react_player_1.default, { id: "outVideo", url: url, controls: true, width: width || "100%", height: height, light: lightPlayer, style: { overflow: "hidden" } })));
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        readOnly ? (createVideoPreview({ value: value })) :
            (value === null || value === void 0 ? void 0 : value.length) > 0 ? (createVideoPreview({ value: value, actionMenuButton: true })) :
                react_1.default.createElement(FileUploadWrapper_1.FileUploadWrapper, { height: '18rem', isLoading: isLoading, uploadProgress: uploadProgress, enableClickUpload: false, mediaType: 'video', handleUpload: handleUpload },
                    react_1.default.createElement(styled_1.StyledInnerWrapper, null,
                        react_1.default.createElement(Buttons_1.ButtonSecondary, { value: "Add Video link", icon: "Plus", onClick: function () { return setShowEmbedLinkModal(true); }, invert: invert }),
                        enableVideoUpload && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(Typo_1.SANS_2, { semibold: true, color: invert ? themes_1.colors.white_opacity60 : themes_1.colors.greyColor80 }, "OR"),
                            react_1.default.createElement(Buttons_1.ButtonSecondary, { onClick: function () { return inputRef.current.click(); }, value: "Upload A Video", icon: "UploadSimple", invert: invert, id: "videoField" }))))),
        showEmbedLinkModal && (react_1.default.createElement(EmbedLinkModal_1.EmbedLinkModal, { setShowEmbedLinkModal: setShowEmbedLinkModal, value: value, createVideoPreview: createVideoPreview, onChange: onChange, id: id, invert: invert })),
        react_1.default.createElement("input", { type: "file" // When user clicks on upload new video from action menu inputRef.current.click() this does not work for upload button. this approch deals with that issue.
            , accept: "video/*", ref: inputRef, style: { display: "none" }, id: "videoField", onChange: function (v) {
                handleUpload({ files: v.target.files });
            } })));
}
exports.default = VideoInput;
